<div class="card">
    <div class="card-body d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
        <div class="m-1 d-flex align-items-baseline flex-column flex-sm-row">
            <h2 class="m-0 mr-2">
                Properties
            </h2>
            <small class="title-description">
                Gestion de properties
            </small>
        </div>
        <div class="d-flex align-items-center gap-0">
            <button mat-icon-button (click)="resetForm()" *ngIf="selectedProperty!=undefined">
                <mat-icon>add_circle_outline</mat-icon>
            </button>
            <button mat-icon-button (click)="getAllProperties()">
                <mat-icon>refresh</mat-icon>
            </button>
        </div>
    </div>
</div>
<form class="card mt-3" [formGroup]="form">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
        <div class="m-1 d-flex align-items-center flex-column flex-sm-row">
            <h2 class="m-0 mr-2">
                {{selectedProperty&&selectedProperty.key ?
                selectedProperty.key : "Crear"}}
            </h2>
        </div>
    </div>
    <div class="card-body row">
        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>Nombre</mat-label>
            <input matInput formControlName="key" type="text" [maxlength]="500"
                (input)="ignoreSpecialCharactersVoid('key',form.get('key')?.value.toUpperCase())">
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-12 col-md-6">
            <mat-label>Estado</mat-label>
            <mat-select formControlName="estado">
                <mat-option [value]="'AC'">Activo</mat-option>
                <mat-option [value]="'IN'">Inactivo</mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-12">
            <mat-label>Valor</mat-label>
            <textarea matInput formControlName="valor" type="text" [maxlength]="4000" rows="5"></textarea>
        </mat-form-field>
    </div>
    <div class="card-footer d-flex align-items-center justify-content-end gap-2">
        <button mat-flat-button class="btn btn-secondary" type="button" *ngIf="selectedProperty!=undefined"
            (click)="modify()"
            [ngClass]="{'btn-primary': selectedProperty==undefined,'btn-secondary': selectedProperty!=undefined}">Modificar</button>
        <button mat-flat-button type="button" (click)="create()" class="btn btn-primary">Crear
            nuevo</button>

    </div>
</form>

<div class="shadow mt-3">
    <coky-table [title]="'Listado'" [description]="'Seleccione un registro para modificar'" [data]="properties"
        (clickRow)="selectProperty($event)" [multipleSelection]="false">
    </coky-table>
</div>